angular.module('modules.page-performance.page-details', ['blocks.router', 'modules.page-performance']);
